// @DEVNOTE 2024 May 14

// CONFIG
// const GRAPHQL_URL = 'https://infasecure-online.myshopify.com/api/2021-04/graphql.json';
// const STOREFRONT_ACCESS_TOKEN = 'ca6a4e07820d36a77e98797a60826e0a';
const GRAPHQL_URL = 'https://infa-group.myshopify.com/api/2023-01/graphql.json';
const STOREFRONT_ACCESS_TOKEN = '6ca7b3b189087dc27968a49b63a806ff';
const MATRIX_CONTAINER_ID = 'matrix-container';
const MATRIX_TABLE_ID = 'matrix-table';


window.addEventListener('load', () => {

  let matrixContainer = document.getElementById(MATRIX_CONTAINER_ID);
  
  // Submit button behaviour
  let submitBtn = document.querySelector('.submitBtn');
  submitBtn.addEventListener('click', () => {

    // Get selected options
    let optionValues = document.querySelectorAll('.optionValue');
    
    // Generate node query
    let nodeQuery = "";

    optionValues.forEach((opt) => {

      let optionValue;
      if (opt.checked) {
        optionValue = opt.value;
      }

      if (optionValue) {
        if (nodeQuery) {
          nodeQuery = nodeQuery + " AND ";  
        }
        
        // Is this option value a custom price range?
        let optionValueName = opt.getAttribute("name")
        if (optionValueName == "priceRange") {
          // Get custom input range fields
          let min = 0;
          let max = 0;
          opt.parentElement.querySelectorAll('.optionValueCustomField').forEach((e) => {
            if (e.getAttribute("name") == "customPriceMin") {
              min = "variants.price:>=" + e.value;
            } else if (e.getAttribute("name") == "customPriceMax") {
              max = "variants.price:<=" + e.value;
            }
          });
          if (min || max) {
            if (min) {
              nodeQuery = nodeQuery + min;
            }
            if (min && max) {
              nodeQuery = nodeQuery + " AND ";
            }
            if (max) {
              nodeQuery = nodeQuery + max;
            }
          } else {
            // Not a custom price range
            nodeQuery = nodeQuery + optionValue;
          }
        } else {
          nodeQuery = nodeQuery + optionValue;
        }
      }

    });

    // Add mandatory tags
    nodeQuery = nodeQuery + " AND tag:'active' AND (tag:'car seat' OR tag:'child restraint')";

    // Send generated node query string to GraphQL query generator function
    let redirectUrl = "";
    fetchProducts(nodeQuery).then( (products) => {

      let productHandlesResult = '';
      if (products) {

        displayProductCards(products);
        
        // Get the product handles
        // products.forEach( (product, index) => {
        //   productHandlesResult += product.handle;
        //   if (index < (products.length - 1)) {
        //     productHandlesResult += ",";
        //   }          
        // });
        
        // Add the product handles to a redirect URL
        // redirectUrl = window.location.href + "?productHandles=" + productHandlesResult;
      }

    }).then ( () => {
      // Redirect to new URL with query string containing product handles
      // window.location.replace(redirectUrl);
    });    

  });

  // Next button behaviour
  let nextBtn = document.querySelectorAll('.nextBtn');
  nextBtn.forEach( (btn, index) => {
    btn.addEventListener('click', (btn) => {
      nextBtnClicked(btn.target);
    });
  });
  
});


function nextBtnClicked(btn) {
  let nextRowId = btn.dataset.target;
  document.querySelector(nextRowId).classList.remove("d-none");
  btn.classList.add("d-none");
}



/**
 * Fetch the products from the generated GraphQL query string
 */
function fetchProducts(queryString) {

  // Clear products in sessionStorage
  // sessionStorage.removeItem("productIds");

  // document.getElementById(MATRIX_CONTAINER_ID).style.display = "none";

  let graphQLQuery = generateGraphQLQueryString(queryString);

  // Get data of selected products from API
  let GRAPHQL_BODY = () => {
    return {
      'async': true,
      'crossDomain': true,
      'method': 'POST',
      'headers': {
        'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
        'Content-Type': 'application/graphql',
      },
      'body': graphQLQuery()
    };
  }

  return fetch(GRAPHQL_URL, GRAPHQL_BODY())
    .then(res => res.json())
    .then(products => {

      let productsReturn = [];

      // // Arrange the resulting array 
      if (products.data.products.edges.length > 0) {
        products.data.products.edges.forEach((item) => {
          productsReturn.push(item.node);
        });

        return productsReturn;

      } else {
        
        Swal.fire({
          title: 'Sorry!',
          text: 'No child restraints with the selected criteria has been found. Please try again.',
          showClass: {
            popup: 'animate__animated animate__fadeInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp'
          },
        });

        return false;
        
      }
        
    });
    
}



/**
 * Generate the GRAPHQL query to retrieve the products by tags chosen in the form
 */
function generateGraphQLQueryString(queryString) {

  let graphQLQuery = () => `
          {
			products(first:50, query:"${queryString}", sortKey:PRICE){
              edges {
                node {
                  id
                  handle
                  title
                  vendor
                  tags
                  productType
                  onlineStoreUrl
                  images(first: 1) {
                    edges {
                      node {
                        originalSrc
                        altText
                      }
                    }
                  }
                  variants(first: 1) {
                    edges {
                      node {
                        sku
                        priceV2 {
                          amount
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          `;

  return graphQLQuery;
}



function displayProductCards(products) {

  let resultsContainer = document.getElementById("matrix-results-container");
  resultsContainer.innerHTML = "";

  products.forEach( (product) => {

    let productPrice = "$" + (product.variants.edges[0].node.priceV2.amount);

    // Correction for cents having 1 digit only if 0
    let productPriceDecimal = productPrice.split(".");
    if (productPriceDecimal[productPriceDecimal.length - 1] == "0") {
      productPrice += "0";
    }

    let productCardHtml = `
      <div class="product-grid-item-custom-col col-12 col-sm-6 col-lg-3 ">
      
        <div class="product-grid-item-custom h-100 mb-4">
          
          <div class="card h-100">
      
            <a href="/products/${product.handle}" class="img-link shadow position-relative">
              <img src="${product.images.edges[0].node.originalSrc}&amp;width=250" alt="${product.title}" width="250" height="1280" loading="lazy" class="contain bright  card-img-top">
            </a>
      
            <div class="card-body text-center">
              
              <a href="/products/${product.handle}">
                <div class="product-card-name-container">
                  <p class="product-card-name">${product.vendor} ${product.title}</p>
                </div>
                <p class="card-subtitle mb-2 product-card-price ">${productPrice}</p>
              </a>
      
            </div>
      
          </div>
        
        </div>
        
      </div>
    `;  

    resultsContainer.insertAdjacentHTML('beforeend', productCardHtml);
    
  });

  // Show header
  document.getElementById("matrix-results-header").style.display = "block";

  // Scroll down to results
  resultsContainer.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  
}